import {
  API_SUCCESS,
  API_PENDING,
  API_FAILURE,
  RESET_INITIAL_STATE,
  INTERNAL_SERVER_ERROR,
  UNPROCESSABLE_ENTITY,
} from '@/constants/Actions'

export type FormStepsState = {
  loading: boolean
  error: boolean
  errorType: string
  errorMessage: string
  success: boolean
  successMessage: string
}

export const formStepsInitialState: FormStepsState = {
  loading: true,
  error: false,
  errorType: '',
  errorMessage: '',
  success: false,
  successMessage: '',
}

export type FormStepsAction =
  | { type: typeof API_PENDING }
  | { type: typeof API_FAILURE; payload: { type: string; message: string } }
  | { type: typeof API_SUCCESS; payload: { message: string } }
  | { type: typeof RESET_INITIAL_STATE }

export const formStepsReducer = (
  state: FormStepsState,
  action: FormStepsAction,
): FormStepsState => {
  const { type } = action

  switch (type) {
    case API_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        errorType: '',
        errorMessage: '',
        success: false,
        successMessage: '',
      }
    case API_FAILURE:
      if ('payload' in action) {
        return {
          ...state,
          loading: false,
          error: true,
          errorType: action.payload.type,
          errorMessage: action.payload.message,
        }
      }
      return state
    case API_SUCCESS:
      if ('payload' in action) {
        return {
          ...state,
          loading: false,
          success: true,
          successMessage: action.payload.message,
        }
      }
      return state
    case RESET_INITIAL_STATE:
      return {
        ...state,
        loading: false,
        error: false,
        success: false,
        successMessage: '',
        errorMessage: '',
      }
    default:
      return state
  }
}

export const formStepsActions = {

}
